import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FormTO} from "../../../../../classes/form-to";
import {ProcessBuilderService} from "../../../../../services/process-builder.service";
import {Subject} from "rxjs";
import {ProcessFlatNode} from "../../../../../classes/process-flat-node";
import {TransformUntilMe} from "../../../../../classes/transform-until-me";
import {Transformation} from "../../../../../classes/transformation";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ProcessTranslationsComponent} from "../../../process-translations/process-translations.component";
import {FileImportTO} from "../../../../../classes/file-import-to";
import {ProcessTemplate} from "../../../../../classes/process-template";
import {ProcessTranslations} from "../../../../../classes/process-translations";
import {UploadComponent} from "../../../../../modules/upload/upload.component";
import {FormService} from "../../../../../services/form.service";
import {ImportTranslationMessageDialogComponent} from "../../../../import-translation-message-dialog/import-translation-message-dialog.component";

@Component({
  selector: 'sprout-designer-handlebars',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './handlebars.component.html',
  styleUrls: ['./handlebars.component.css']
})
export class HandlebarsComponent implements OnInit {

  @Input()
  processNode: ProcessFlatNode;

  @Output() templateChangeEvent = new EventEmitter<string>();

  @Output() formModelChangeEvent = new EventEmitter<string>();

  @ViewChild(UploadComponent) uploadComponent:UploadComponent;

  public fileImportTO: FileImportTO;

  handlebarsEditor: monaco.editor.IStandaloneCodeEditor;

  public form: FormTO;

  public model: any;
  public html: any;
  public modelView: string;

  context = this;
  handlebarsEditorDeclarations: any;

  monacoHtmlOptions:any = {theme: 'vs',
    language: 'html',
    readOnly: false,
    automaticLayout: true,
    minimap: {
      enabled: false
    },
    printMargin: false,
    readonly: true};

  monacoHandlebarsOptions:any = {theme: 'vs',
    language: 'handlebars',
    readOnly: false,
    automaticLayout: true,
    wordWrap: 'on',
    scrollbar: 'hidden',
    glyphMargin: false,
    minimap: {
      enabled: false
    },
    printMargin: false};

  monacoJsonOptions:any = {theme: 'vs',
    language: 'json',
    readOnly: true,
    automaticLayout: true,
    minimap: {
      enabled: false
    },
    printMargin: false,
    readonly: true};
  // options:any = {printMargin: false, theme: 'vs-dark'};
  // template: string = '<html>\n' +
  //     '    <body>\n' +
  //     '        {{#i18n "greeting"}}Hello{{/i18n}}, {{model.firstName}}!\n' +
  //     '    </body>\n' +
  //     '</html>';
  template: string;

  private _formValue = new Subject();
  formValue$ = this._formValue.asObservable();
  processTranslations: ProcessTranslations;
  private formValue: any;
  modelInitialized: boolean;
  htmlInitialized: boolean;

  constructor(private formService: FormService, private processBuilderService: ProcessBuilderService, public dialog: MatDialog, private changeDetectorRef: ChangeDetectorRef) {

    // this.form = processBuilderService.form;
    //
    // if (this.processNode) {
    //   processBuilderService.processNode = this.processNode;
    // } else {
    //   this.processNode = processBuilderService.processNode;
    // }
    //
    // this.processNode.formId = this.form.id;

    if (this.processBuilderService.form && this.processBuilderService.form.id) {

      const formId: number = this.processBuilderService.form.id;
      const formTmp = new FormTO();
      formTmp.id = formId;

      this.formService.getFormTOModel(formTmp).subscribe(model => {

        console.log('here...here');
        
        if (model) {
          formTmp.model = JSON.stringify(model);

          this.processBuilderService.getFormModel(formId).subscribe(booleanTO => {
            if (booleanTO.message) {
              formTmp.value = booleanTO.message;
            }

            this.form = formTmp;

            if (this.processNode) {
              this.processBuilderService.processNode = this.processNode;
            } else {
              this.processNode = this.processBuilderService.processNode;
            }

            this.processNode.formId = this.form.id;
            this.changeDetectorRef.detectChanges();
          });
        }
      });
    }


  }


  ngOnInit(): void {
    console.log('ngOnInit.getting template...');
    this.processBuilderService.getTemplate(this.processNode).subscribe(process => {
      console.log('got template!!!!');
      this.templateInitialized = true;
      this.template = process.template;
      this.runnerProcessUntilMe(this);
    }, error => {
      console.error('ngOnInit.getTemplate error.');
    });
  }

  timerProcessUntilMe = -1;
  templateInitialized: boolean;

  runnerProcessUntilMe(parent: any) {

    console.log('runnerProcessUntilMe');
    this.timerProcessUntilMe = -1;

    parent.formModelChangeEvent.emit(this.formValue);

    const transformUntilMe = new TransformUntilMe();
    transformUntilMe.process = this.processNode;
    transformUntilMe.input = this.formValue;
    transformUntilMe.inputContentType = 'application/json';

    this.processBuilderService.processUntilMe(transformUntilMe).subscribe(response => {
      this.modelInitialized = true;
      console.log('processUntilMe.response:');
      console.dir(response);

      if (response.outputContentType && response.outputContentType === 'application/json') {
        // console.log('name: ' + response.output['firstName']);

        this.model = response.output;
        this.modelView = JSON.stringify(this.model, null, 3);
        this.changeDetectorRef.detectChanges();

        this.onExecuteTemplate();
      }

    }, error => {
      console.error("EOROR");
    });

  }

  onFormValueChange(formValue: any, parent: any) {
    // console.log('onFormValueChange.formValue:');
    // console.dir(formValue);
    // console.log('onFormValueChange.processNode:');
    // console.dir(this.processNode);

    if (formValue) {
      this.formValue = formValue;

      if (!this.timerProcessUntilMe || this.timerProcessUntilMe == -1) {
        this.timerProcessUntilMe = setTimeout(function() {parent.runnerProcessUntilMe(parent)}  , 2000); // auto-save every 5 seconds (assuming template has been changed)
      }
    }
  }

  public onExecuteTemplate() {
    console.log('onExecuteTemplate');
    // console.dir(this.template);
    // console.dir(this.model);

    const transformation: Transformation = new Transformation();
    transformation.processType = this.processNode.processType;
    transformation.template = this.template;
    transformation.input = JSON.stringify(this.model);
    transformation.inputContentType = 'application/json';
    this.processBuilderService.execute(transformation).subscribe(transformation => {

      this.htmlInitialized = true;
      // console.log('execute:');
      // console.dir(transformation);

      if (transformation) {
        if (!transformation.errorInd) {
          if (transformation.outputContentType && transformation.outputContentType == 'application/html') {
            this.html = transformation.output;
            this.changeDetectorRef.detectChanges();

            if (this.handlebarsEditor) {
              monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', []);
            }

            this.handlebarsEditorDeclarations = undefined;
          }
        } else {
          if (transformation.message) {

            const messageParts: any[] = transformation.message.split(":");
            // console.log('messageParts');
            // console.dir(messageParts);

            if (messageParts && messageParts.length > 3) {
              const line: number = messageParts[1] as number;
              const position: number = messageParts[2] as number;

              if (line && position) {

                // console.log('line type: ' );

                // const lineTest = 3;
                // const positionTest = 30;

                // console.log('line: ' + line);
                // console.log('position: ' + position);

                let message = '';

                for (var _i = 3; _i < messageParts.length; _i++) {
                  if (_i > 3) message += "\n";
                  message += messageParts[_i];
                }

                if (this.handlebarsEditor) {
                  monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', [{
                    startLineNumber: +line,
                    startColumn: +position + 1,
                    endLineNumber: +line,
                    endColumn: 1000,
                    message: message,
                    severity: monaco.MarkerSeverity.Error
                  }]);
                }
                // monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', [{
                //   startLineNumber: line,
                //   startColumn: position,
                //   endLineNumber: line + 1,
                //   endColumn: 1000,
                //   message: message,
                //   severity: monaco.MarkerSeverity.Error
                // }])


                //
              }
            }

            // jolt.component.ts:137 inline@5e935c02:3:29: found: '{{!\n    </body>\n</html>'
            // Hello, {{firstName}} {{!


            // this.handlebarsEditorDeclarations = this.handlebarsEditor.deltaDecorations([], [
            //   {
            //     range: new monaco.Range(3,1,3,1),
            //     options: {
            //       isWholeLine: true,
            //       className: 'myContentClass',
            //       glyphMarginClassName: 'myGlyphMarginClass'
            //     }
            //   }
            // ]);

            console.error(transformation.message);
          }
        }
      }

    });
  }

  onInitHandlebarsEditor(editor: monaco.editor.IStandaloneCodeEditor, parent) {
    if (!editor) {
      return;
    }

    this.handlebarsEditor = editor;

    let timerUpdateView = -1;
    let runnerUpdateView = function() {
      timerUpdateView = -1;
      parent.onExecuteTemplate()
    }

    let timerAutoSave = -1;
    let runnerAutoSave = function() {
      timerAutoSave = -1;
      parent.templateChangeEvent.emit(parent.template);
    }

    editor.onDidChangeModelContent(() => {
      if (timerUpdateView !== -1) {
        clearTimeout(timerUpdateView);
      }
      timerUpdateView = setTimeout(runnerUpdateView, 500); // update view every 1/2 second (assuming template has been changed)

      if (timerAutoSave !== -1) {
        clearTimeout(timerAutoSave);
      }
      timerAutoSave = setTimeout(runnerAutoSave, 2000); // auto-save every 5 seconds (assuming template has been changed)
      // timerAutoSave = setTimeout(runnerAutoSave, 5000); // auto-save every 5 seconds (assuming template has been changed)

      // const template = editor.getModel().getValue();
    });
  }

  onTranslate() {
    // console.log('onTranslate');

    this.templateChangeEvent.emit(this.template);

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';

    const processTemplate = new ProcessTemplate();
    processTemplate.process = this.processNode;

    dialogConfig.data = processTemplate;

    const dialogRef = this.dialog.open(ProcessTranslationsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
        processTranslationsRaw => {
          this.processTranslations = processTranslationsRaw as ProcessTranslations;
          // console.log("Dialog output:", this.processTranslations);
        }
    );

  }

  onImportTranslations() {
    this.uploadComponent.openUploadDialog();
  }

  onExportTranslations() {
    if (this.form.id &&
        this.processNode.key) {
      window.location.assign('/rest/form/export/translations?f=' + this.form.id + '&p=' + this.processNode.key);
    }
  }

  setFileImportTO(fileImportTO: FileImportTO) {
    // console.log('setFileImportTO');
    // console.dir(fileImportTO);
    this.fileImportTO = fileImportTO;
    this.importTranslations();
  }

  private importTranslations() {
    // console.log('%c importTranslations.processTemplate:', 'background: #222; color: #bada55');
    // console.dir(this.processTemplate);
    if (this.form.id &&
        this.processNode.key &&
        this.fileImportTO) {
      this.fileImportTO.formId = this.form.id;
      this.fileImportTO.processKey = this.processNode.key;

      this.processBuilderService.importTranslations(this.fileImportTO).subscribe(processTranslationsRaw => {
        // console.log('importTranslations complete!');
        // console.dir(processTranslationsRaw);
        this.processTranslations = processTranslationsRaw as ProcessTranslations;
        // console.log("Dialog output:", this.processTranslations);
        // this.onFormValueChange(this.formValue, this);
        this.runnerProcessUntilMe(this);
      }, error => {
        // console.log('error');
        console.error(error.error.message);

        this.dialog.open(ImportTranslationMessageDialogComponent, {
          data: {
            error: error
          }
        });
      });
    } else {
      console.error("Failed to save translations; process not defined.");
    }
  }

  onResize() {
    console.log('onResize');
    window.dispatchEvent(new Event('resize'));
  }
}
